import React, { useState } from 'react'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { IssuesNotifications } from './components/IssuesNotifications'
import NotificationsBadge from './components/NotificationsBadge/NotificationsBadge'
import { useEscalatedIssuesPolling } from './hooks/useEscalatedIssuesPolling'

const useIssuesContainerStyles = makeStyles(theme => ({
  root: {
    height: 48,
    lineHeight: '48px',
    zIndex: theme.zIndex.drawer + 1,
    '&:hover $notificationsWindow': {
      display: 'block',
    },
  },
  link: {
    cursor: 'pointer',
    padding: '0 16px',
    color: brandColors.white,
    '&:hover': {
      color: brandColors.white,
    },
  },
  notificationsWindow: {
    display: 'none',
    overflow: 'visible',
    width: '30vw',
    minWidth: '600px',
    maxWidth: '1000px',
    height: 'auto',
    margin: 0,
    padding: 0,
    position: 'absolute',
    top: 48,
    left: '-100%',
    transform: 'translateX(-75%)',
    border: `0.5px solid ${brandColors.coolGray5}`,
    boxShadow: `0px 4px 4px rgba(0, 0, 0, 0.25)`,
    backgroundColor: brandColors.white,
    color: brandColors.coolGray8,
  },
}))

/**
 * Handles fetch and mutation logic for stateless children Issue list components
 */
const IssuesContainer = () => {
  const [hover, setHover] = useState<boolean>(false)
  const classes = useIssuesContainerStyles()

  const { data: escalatedIssues, issueCount } = useEscalatedIssuesPolling()

  const mouseEnterHandler = () => {
    if (issueCount > 0) {
      setHover(true)
    }
  }

  const mouseLeaveHandler = () => {
    setHover(false)
  }

  return (
    <div className={classes.root} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
      <a aria-label='Notifications' href={`${__ROOT__}/issues`} className={classes.link}>
        <NotificationsBadge issuesCount={issueCount} hover={hover} />
      </a>
      {issueCount > 0 && (
        <IssuesNotifications
          className={classes.notificationsWindow}
          escalatedIssues={escalatedIssues}
          issueCount={issueCount}
        />
      )}
    </div>
  )
}

export default IssuesContainer
